import React from "react";

function AboutSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-extrabold text-primary mb-6">About Us</h2>
        <p className="mt-4 text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
          Chiranthan Enterprises is a visionary company leading innovation across industries 
          such as IT & Software, Real Estate, Fashion, and Infrastructure. 
          Our mission is to empower communities and businesses with excellence and sustainability.
        </p>
        
        {/* Decorative Elements */}
        <div className="mt-12 flex justify-center">
          <div className="w-12 h-1 bg-gradient-to-r from-primary to-secondary"></div>
        </div>
        
        {/* Stats Section */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-3xl font-bold text-gray-900">5+</h3>
            <p className="text-gray-600">Industries</p>
          </div>
          <div>
            <h3 className="text-3xl font-bold text-gray-900">3+</h3>
            <p className="text-gray-600">Years of Innovation</p>
          </div>
          <div>
            <h3 className="text-3xl font-bold text-gray-900">20+</h3>
            <p className="text-gray-600">Happy Customers</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
